module.exports = "<ng-container *ngIf=\"temperature || temperature == 0\">{{ temperature | unitConversion : true : \"temperature\" }}</ng-container> ";